/**
 * Dev-only login bypass for click-through testing (e.g. `/apartment` AI
 * renders) without the login wall. Off unless BOTH hold:
 *   - a Vite dev server (`import.meta.env.DEV`; `vite build` drops this code),
 *   - `VITE_DEV_AUTO_LOGIN=1` in its environment.
 * It signs in as the mock provider's first seed account (`/dev/seed-users`,
 * which is empty on every real deployment) and activates the demo org, so
 * real auth stays the only path everywhere else.
 */
import { getSeedUsers, login, refresh } from './endpoints/auth'
import {
  listOrganizations,
  setActiveOrganization,
} from './endpoints/organizations'

export const DEV_AUTO_LOGIN =
  import.meta.env.DEV && import.meta.env.VITE_DEV_AUTO_LOGIN === '1'

const DEMO_ORG = 'Archigma Demo'

let pending: Promise<boolean> | null = null

/** Signs in as the seed admin; `false` when disabled or no seed accounts. */
export function devAutoLogin(): Promise<boolean> {
  if (!DEV_AUTO_LOGIN) return Promise.resolve(false)
  pending ??= signIn().finally(() => {
    pending = null
  })
  return pending
}

async function signIn(): Promise<boolean> {
  const [seed] = (await getSeedUsers()).users
  if (!seed) return false
  await login(seed.email, seed.password)
  const orgs = await listOrganizations()
  const org = orgs.find((item) => item.name === DEMO_ORG) ?? orgs[0]
  if (org) {
    await setActiveOrganization(org.id)
    await refresh()
  }
  console.info(`[dev] auto-login as ${seed.email}${org ? ` (${org.name})` : ''}`)
  return true
}
